//#region Function Imports
import React, { useState, useEffect } from 'react'
import { FlatList, StyleSheet, Platform, SafeAreaView, View, useWindowDimensions, Linking } from 'react-native'
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomButton from '../../../components/CustomButton/CustomButton';
import { Card } from 'react-native-paper';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../styles/commonStyles';
import { useTranslation } from 'react-i18next';
//#endregion

const MySurveysAdmin = (props) => {

    //#region Function Consts
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions()
    const { colors } = useTheme()
    const styles = makeStyles(colors, height, width);
    const common = createCommonStyles(colors);
    const [loading, setLoading] = useState(false);

    const openSurveyLink = async (surveyId) => {
        const surveyUrl = `${window.location.origin}/Surveys/${encodeURIComponent(surveyId)}`;

        try {
            await Linking.openURL(surveyUrl);
        } catch (error) {
            console.error(error);
        }
    };
    //#endregion

    //#region UseEffect
    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    //#endregion

    //#region Render Functions
    const SurveyAdminListView = (item) => {
        return (
            <View style={styles.showhide}>
                <SafeAreaView>
                    <SafeAreaView style={styles.item}>
                        <SafeAreaView
                            style={styles.row}>
                            <CustomLabel
                                value={item.survey_name}
                                type='AVAILABLEUSED' />
                            <View style={styles.verticalLine} />
                            {item.completed_on !== null ?
                                <View
                                    style={styles.button}>
                                    <CustomButton
                                        iconName='eye-outline'
                                        onPress={() => {
                                            props.setShowMySurveys(0)
                                            props.setShowResponseScreen(0)
                                            props.setShowResultsScreen(1)
                                            props.setShowMySurveys(0)
                                            props.setShowSurveysAdmin(0)
                                            props.setShowCreateScreen(0)
                                            props.setShowEditScreen(0)
                                            props.setResponseSurveyId(item.id)
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={20} />
                                    {!item.require_login &&
                                        < CustomButton
                                            iconName='link-outline'
                                            onPress={() => openSurveyLink(item.id)}
                                            show='HOME_BELL'
                                            type='HOME_BELL'
                                            textTop='2'
                                            sz={20} />}
                                </View>
                                :
                                <View
                                    style={styles.button}>
                                    <CustomButton
                                        iconName='pencil-outline'
                                        onPress={() => {
                                            props.setShowMySurveys(0)
                                            props.setShowResponseScreen(0)
                                            props.setShowMySurveys(0)
                                            props.setShowSurveysAdmin(0)
                                            props.setShowCreateScreen(0)
                                            props.setShowEditScreen(1)
                                            props.setResponseSurveyId(item.id)
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={20} />
                                    <CustomButton
                                        iconName='trash-outline'
                                        onPress={() => {
                                            props.setDeleteSurvey(1)
                                            props.setResponseSurveyId(item.id)
                                        }}
                                        // onPress={() => { navigation.navigate('ResultsSurvey', { id: item.id }) }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={20} />
                                    {!item.require_login &&
                                        < CustomButton
                                            iconName='link-outline'
                                            onPress={() => openSurveyLink(item.id)}
                                            show='HOME_BELL'
                                            type='HOME_BELL'
                                            textTop='2'
                                            sz={20} />}
                                </View>}

                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            </View>
        )
    }

    const renderSurveys = ({ item }) => {
        return (
            <Card
                style={common.cardstyle} >
                <Card.Content>
                    <SurveyAdminListView {...item} />
                </Card.Content>
            </Card >
        )
    };
    //#endregion

    return (
        <SafeAreaView
            style={styles.mainView}>
            <View style={styles.listWrapper}>
                <FlatList
                    data={props.data}
                    renderItem={renderSurveys}
                    onRefresh={() => props.loadEverySurvey()}
                    scrollEnabled={true}
                    refreshing={loading}
                    keyExtractor={item => `${item.id}`}
                    initialNumToRender={4}
                    ListHeaderComponent={
                        <SafeAreaView style={common.listTitle}>
                            <View style={styles.row}>
                                <CustomLabel
                                    value={t('common:surveyname')}
                                    type='SUBTITLE' />
                                <View style={styles.verticalLine} />
                                <View style={styles.row}>
                                    <CustomLabel
                                        value={t('common:surveyAdminFunction')}
                                        type='SUBTITLE' />
                                    <CustomButton
                                        onPress={() => {
                                            props.setShowMySurveys(0)
                                            props.setShowSurveysAdmin(0)
                                            props.setShowCreateScreen(1)
                                            // props.setResponseSurveyId(item.id)
                                        }}
                                        iconName='add-outline'
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='0'
                                        sz={30}
                                    />
                                </View>
                            </View>
                            <SafeAreaView style={common.divider} />
                        </SafeAreaView>
                    }

                />
            </View>
        </SafeAreaView>
    )
}

const makeStyles = (colors, height, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        height: (Platform.OS === 'web' ? height * 60 / 100 : '95%'),
        justifyContent: 'center',
    },
    listWrapper: {
        flex: 1,
        padding: 10,
        marginBottom: 10
    },
    row: {
        flex: 1,
        flexDirection: "row"
    },
    button: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: "center",
        alignItems: "center",
    },
    verticalLine: {
        backgroundColor: colors.buttons_primary,
        height: '100%',
        width: 1,
    },
})

export default MySurveysAdmin
